module.exports = __webpack_public_path__ + "static/media/form-builder-2.495019b8.png";